import { MouseEvent, useState } from "react";
import { getTheme, setTheme, Theme } from "../../utils/theme";
import FeatherIcon from "feather-icons-react";
import styles from './theme-toggle.module.scss';

export function ThemeToggle() {
  const [localTheme, setLocalTheme] = useState<Theme>(getTheme());

  function toggle(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    
    if (localTheme === "dark") {
      setLocalTheme("light");
      setTheme("light");
    } else {
      setLocalTheme("dark");
      setTheme("dark");
    }
  }

  return (
    <a href="#" className={styles.button} onClick={toggle}>
      <FeatherIcon icon={localTheme === 'dark' ? 'sun' : 'moon'} />
    </a>
  );
}
